import { PreviewAspectRatio, PreviewSize, Scale } from "../models";

export const calculateDimensions = (
    aspectRatio: PreviewAspectRatio = PreviewAspectRatio.nineSixteen,
    scale = Scale.Percent100,
): { width: number; height: number } => {
    const baseWidth = aspectRatio === PreviewAspectRatio.nineSixteen ? PreviewSize.width : 135;
    const baseHeight = aspectRatio === PreviewAspectRatio.nineSixteen ? PreviewSize.height : 180;
    const multiplier = scale;

    return {
        width: baseWidth * multiplier,
        height: baseHeight * multiplier,
    };
};
